<template>
  <v-content>
    <v-container>
      <v-layout>
        <v-card width="100%" class="mb-2" ripple flat>
          <v-layout row class="pb-3">
            <v-flex xs12>
              <h4 class="strong">{{ name }}</h4>
            </v-flex>
          </v-layout>

          <v-layout row>
            <v-flex xs3 class="ml-3">
              <v-icon color="primary">phone</v-icon>
            </v-flex>
            <v-flex xs9>
              <div v-for="(num, i) in phoneNumbers" :key="i">
                <a :href="'tel:' + num" :tabIndex="-1">{{ num }}</a>
              </div>
            </v-flex>
          </v-layout>

          <v-layout row>
            <v-flex xs3 class="ml-3">
              <v-icon color="primary">location_on</v-icon>
            </v-flex>
            <v-flex xs9>
              <a :href="url" :tabIndex="-1" target="_blank">
                View Location
              </a>
            </v-flex>
          </v-layout>
        </v-card>
      </v-layout>
    </v-container>
  </v-content>
</template>

<script>
export default {
  name: "PageContact",
  props: {
    name: String,
    phoneNumbers: Array,
    url: String
  }
};
</script>
